import { render } from "./AccountsReceivable.vue?vue&type=template&id=562ba72f&ts=true"
import script from "./AccountsReceivable.vue?vue&type=script&lang=ts"
export * from "./AccountsReceivable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__